import { useEffect, useState } from "react"
import { useAccount } from "wagmi";
import { getMultiCall, getWeb3Contract } from "../helper/contractHelper";
import { getCurrentChain } from "../helper/functions";
import { CHAIN_INFO } from "../helper/constant";
import nftABI from '../abis/nft721.json';
import nft1155ABI from '../abis/nft1155.json';
import nftauctionABI from '../abis/nftauction.json';
import multicallABI from '../abis/multicall.json';



export const useCreateSaleStats = (nfttype = 1, nftAddress = '', tokenId = '' , updater) => {
    const { chainId, address } = useAccount();
    const [stats, setStats] = useState({
        balance: 0,
        bstBalance: 0,
        fees: 0,
        isApproved: false
    });

    let currentChain = getCurrentChain(chainId);
    const sc = getWeb3Contract(nfttype === "ERC-721" ? nftABI : nft1155ABI, nftAddress, currentChain)
    const ac = getWeb3Contract(nftauctionABI, CHAIN_INFO[currentChain].nft_auction, currentChain)
    const mc = getWeb3Contract(multicallABI, CHAIN_INFO[currentChain].multicall_address, currentChain)

    useEffect(() => {
        const fetch = async () => {
            try {
                let data;
                console.log(nfttype)
                console.log(sc)
                if (nfttype === 'ERC-721') {
                    data = await getMultiCall([
                        sc.methods.ownerOf(tokenId),
                        mc.methods.getEthBalance(address),
                        sc.methods.isApprovedForAll(address, CHAIN_INFO[currentChain].nft_auction),
                        ac.methods.feesPercentage()
                    ], currentChain);
                }
                else {
                    data = await getMultiCall([
                        sc.methods.balanceOf(address, tokenId),
                        mc.methods.getEthBalance(address),
                        sc.methods.isApprovedForAll(address, CHAIN_INFO[currentChain].nft_auction),
                        ac.methods.feesPercentage()
                    ], currentChain);
                }


                setStats({
                    balance: nfttype === 'ERC-721' ? data[0] && data[0].toLowerCase() === address.toLowerCase() ? 1 : 0 : data[0],
                    bstBalance: data[1] / Math.pow(10,18),
                    fees: data[3] / 100,
                    isApproved: data[2]
                });
            }
            catch (err) {
                console.log(err.message);
            }
        }

        if (nfttype && nftAddress && address && tokenId !== '') {
            fetch();
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chainId, address, nftAddress, nfttype , updater]);

    return stats;
}